import { restClient } from '../client';
import { TimeRange, WeekDayKeys } from '@uplift/types';


export type UserAvailabilityForRangeInput = {
  datetime_from: string;
  datetime_to: string;
};


export type UserAvailabilityForRangeSlotsOutput = {
  timezone: string;
  overrides: Record<string, TimeRange[]>;
  template: Record<WeekDayKeys, TimeRange[]>;
};


export type UserAvailabilityForRangeRangesOutput = {
  timezone: string;
  overrides: Record<string, TimeRange[]>;
  template: Record<WeekDayKeys, TimeRange[]>;
};


export type UserAvailabilityForRangeOutput = UserAvailabilityForRangeSlotsOutput | UserAvailabilityForRangeRangesOutput;


export const userAvailabilityForRange = (params: UserAvailabilityForRangeInput) => restClient.rawRequest<UserAvailabilityForRangeOutput>('/api/v1/availability/for_range', {
  method: 'GET',
  params: params
});
